import {SAVE_LEGEND} from "./types";

export function saveLegend(payload) {
    return {
        type: SAVE_LEGEND,
        payload: payload
    };
}